import { render, staticRenderFns } from "./StandingEditModal.vue?vue&type=template&id=90d6d594"
import script from "./StandingEditModal.vue?vue&type=script&lang=ts"
export * from "./StandingEditModal.vue?vue&type=script&lang=ts"
import style0 from "./StandingEditModal.vue?vue&type=style&index=0&id=90d6d594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports